<template>
    <el-dialog
        title="Confirmación"
        :visible="cancelDialogVisible"
        width="30%"
        align="left"
        @close="closeDialog"
        @visible-change="closeDialog"
        v-on:update:visible="closeDialog">
        <span>{{ cancelText }}</span>
        <span slot="footer" class="dialog-footer">
            <el-button type="success" @click="cancelTicket">Cancelar ticket</el-button>
            <el-button type="danger" @click="closeDialog">No cancelar</el-button>
          </span>
    </el-dialog>
</template>

<script>
import { cancelTicket } from "@/api/tickets.js"
export default {
    props: {
        cancelDialogVisible : {
            required: true,
            default: false
        },
        cancelNumberTicket : {
            required: true
        },
        cancelText : {
            required: true
        },
        tableData : {
            required: true
        },
    },
    methods: {
        cancelTicket(){

            this.closeDialog();
            
            cancelTicket(this.cancelNumberTicket)
            .then(response => {
              if(response.status == "success"){
                this.tableData.find(row => row.number == this.cancelNumberTicket).status = "Cancelado";
                this.tableData.find(row => row.number == this.cancelNumberTicket).current_status = "cancelled";
              }

              this.showMessage(response.message, response.status);

            })
            .catch(error => {
              console.log(error);
            });
        },
        closeDialog(){
            this.$emit("close");
        },
        showMessage(msg, type) {
            this.$message({
            timeout: 80000,
            message: msg,
            type: type,
            });
        },

    }
}
</script>